export const DEFAULT_WAIVER_TEXT = `1. Liability Waiver

By participating in this event, you acknowledge and agree to the following:
• Participation in this activity involves inherent risks, including personal injury, illness, or property damage.
• You voluntarily assume all risks and release CauseConnect, its officers, employees, and agents from any claims or liabilities arising from your participation in this event.
• For participants under 18 years of age, you confirm that you are the parent or legal guardian and accept these terms on their behalf.

2. Default Agreement Notice

This liability waiver is a default condition for participation and does not require separate acceptance.

3. Photo and Media Release

By selecting "I Agree" below, you grant CauseConnect the irrevocable right to capture and use your photographs, videos, or other media for promotional, educational, and other purposes related to the organization's mission. This includes but is not limited to:
• Print materials
• Online platforms
• Social media content
• You understand and agree that no royalties or compensation will be provided for the use of such media.
• If you are a parent or guardian of a minor participant, you grant the same rights on their behalf.`

export const DEFAULT_TERMS_AND_CONDITIONS = `1. Liability Waiver
By participating in this event, you acknowledge and agree to the following:
• Participation in this activity involves inherent risks, including personal injury, illness, or property damage
• You voluntarily assume all risks and release CauseConnect, its officers, employees, and agents from any claims or liabilities arising from your participation in this event
• For participants under 18 years of age, you confirm that you are the parent or legal guardian and accept these terms on their behalf

2. Default Agreement Notice
This liability waiver is a default condition for participation and does not require separate acceptance.

3. Photo and Media Release
By selecting "I Agree" below, you grant CauseConnect the irrevocable right to capture and use your photographs, videos, or other media for promotional, educational, and other purposes related to the organization's mission. This includes but is not limited to:
• Print materials
• Online platforms
• Social media content
• You understand and agree that no royalties or compensation will be provided for the use of such media
• If you are a parent or guardian of a minor participant, you grant the same rights on their behalf`

export type CancellationPolicyType = "full_refund" | "partial_refund" | "non_refundable"

export const CANCELLATION_POLICIES: { value: CancellationPolicyType; label: string; terms: string }[] = [
  {
    value: "full_refund",
    label: "Full Refund",
    terms: "100% refund if cancelled 7 days before the event"
  },
  {
    value: "partial_refund",
    label: "Partial Refund",
    terms: "50% refund if cancelled 7 days before the event"
  },
  {
    value: "non_refundable",
    label: "Non-Refundable",
    terms: "No refund available for this event"
  }
]

export const DEFAULT_CANCELLATION_POLICY = CANCELLATION_POLICIES[2].value as CancellationPolicyType

export const DEFAULT_CANCELLATION_TERMS = CANCELLATION_POLICIES[2].terms

export const DEFAULT_WHATS_INCLUDED = `• All event related materials and supplies
• Event promotion materials
• Post-event impact report
• Post-event photos`

export const DEFAULT_FAQS = `1. What is included in the event?
• A detailed agenda of activities
• Materials required for the event (if provided)
• Support from the host or NPO representatives
• Refreshments or meals (if applicable)

2. Where will the event be held?
• Event location details are included in the listing (physical address for on-site events or virtual meeting links for online events)

3. How do I prepare for the event?
• Volunteers will receive a preparation guide, including recommended attire, materials needed, and any required documentation

4. What is the minimum or maximum number of participants?
• Each event lists the minimum and maximum volunteer capacity. This ensures a balanced and effective experience

5. What happens if the event is canceled?
• You will be notified immediately and can reschedule or request a refund`
